// extracted by mini-css-extract-plugin
export default {"pageDescription":"ProjectsTablesPage_pageDescription__TsL6z"};